import _ from "lodash";

class ConnectedServices {
    static getStatus(device, uuid) {
        let connectedServiceStatus = {};
        const { state, isLinkedWithCustomer, deviceDetails } = device || {},
            subState = _.get(device, `deviceProfile.deviceStatus`, {}),
            customerId = _.get(device, `deviceProfile.customerId`, {});

        if (!device) {
            connectedServiceStatus = {};
        }

        let status = `DISABLED`;
        const isDeviceLinkedWithUuid = isLinkedWithCustomer && customerId === uuid;
        if (state === `ACTIVATION`) {
            status = subState !== `ACTIVATION` && isDeviceLinkedWithUuid ? `ACTIVATING` : `ACTIVATION`;
        } else if (state === `ACTIVE`) {
            if (subState !== `ACTIVE`) {
                status = `DEACTIVATING`;
            } else if (isDeviceLinkedWithUuid) {
                status = `ACTIVE`;
            } else {
                status = `ACTIVATION`;
            }
        }

        connectedServiceStatus.L1 = !!device;
        connectedServiceStatus.L3 = status === `ACTIVE`;
        connectedServiceStatus.status = status;
        connectedServiceStatus.ecallOnly =
            deviceDetails && deviceDetails.ecallOnly && deviceDetails.ecallOnly.toUpperCase() === `Y`;

        return connectedServiceStatus;
    }

    static getDCMDeviceType(devices) {
        const dcmDevices = [
            [`AVMAP`, `VCDCM`],
            [`AVMAP_PIN4`, `PIN 4`],
            [`AVMAP_PIN4_I`, `PIN 4 I`],
            [`AVMAP_TMR`, `Russia VCDCM`],
            [`ECALL`, `18 DCM`],
            [`DCM19`, `19 DCM`],
            [`PSA_ATB`, `PSA ATB`]
        ];
        const dcmDevicesMap = new Map(dcmDevices);
        const dcmDevice = devices.find((device) => dcmDevicesMap.has(_.get(device, `provider`)));

        if (dcmDevice) {
            const dcmType = _.get(dcmDevice, `deviceDetails.dcmType`);
            const dcmName = dcmDevicesMap.get(_.get(dcmDevice, `provider`));
            return dcmName + (dcmType ? ` step ` + dcmType : ``);
        }
    }
}

export default ConnectedServices;
